import { render } from "./OpenPOCardList.vue?vue&type=template&id=0c230331&scoped=true"
import script from "./OpenPOCardList.vue?vue&type=script&lang=js"
export * from "./OpenPOCardList.vue?vue&type=script&lang=js"

import "./OpenPOCardList.vue?vue&type=style&index=0&id=0c230331&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c230331"]])

export default __exports__